import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import styled from 'styled-components';
import { Header, Table } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import CheckBox from 'components/final-form/CheckBox';
import { numberFormatter } from 'utils/fomattingUtils';
import moment from 'moment';
import { ExtendedCollectiveBillDataDto } from 'components/billing/collective-bill/CollectiveBillView';
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';

const StyledFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 550px;
`;

const ScrollableTableWrapper = styled.div`
  flex: 1 1 auto;
  height: 100%;
  min-height: 250px;
  max-height: 315px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  border: 1px solid rgba(34,36,38,.15);
  box-shadow: none;
  border-radius: .28571429rem;

  & .ui.table {
    border: none;
  }

   & .ui.table thead tr:first-child > th {
      position: sticky !important;
      top: 0;
      z-index: 2;
      background: #fff;
  }

  & .ui.table tbody tr.disable-row, .ui.table tr.active.disable-row {
    color: #757575 !important;
  }

  & .ui.table tbody tr:last-child > td {
      border-bottom: 1px solid rgba(34,36,38,.15)
  }
`;

interface Props extends MessageSourceProps, AuthConsumerRenderProps {
  selected?: ExtendedCollectiveBillDataDto,
  onChangeSelected: (collectiveBillDataDto: ExtendedCollectiveBillDataDto) => void
}

class CollectiveBillTreatmentsTable extends Component<Props> {

  render(): React.ReactElement {

    const { selected, currentUser, onChangeSelected, getMessage } = this.props;

    const userMandateId = currentUser!.userConfig.mandateId;

    return (
        <StyledFlexContainer>
          <Header>{getMessage("collectiveBill.dueTreatment")}</Header>
          <ScrollableTableWrapper>
            <Table celled selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{getMessage('collectiveBill.used')}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage('date')}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage('tariff')}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage('price')}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage('patient.externalId')}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage('patient.patientExternalId')}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage('patient')}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage('city')}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage('patient.birthDate')}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <FieldArray name="treatments">
                  {({ fields }) =>
                      fields.map((field, index: number) => {

                        const treatment: ExtendedCollectiveBillDataDto = fields.value[index];
                        const isSelected = selected && selected.treatmentId == treatment.treatmentId;

                        const disableSelect = treatment.mandateId !== userMandateId;

                        return (
                            <Table.Row
                                key={index}
                                active={isSelected}
                                onClick={() => onChangeSelected(treatment)}
                                className={disableSelect ? "disable-row" : ""}
                            >
                              <Table.Cell width={2}>
                                <Field
                                    name={`${field}.used`}
                                    component={CheckBox}
                                    disabled={disableSelect}
                                />
                              </Table.Cell>
                              <Table.Cell width={2}>
                                {moment(treatment.treatmentDate).format("DD.MM.YYYY")}
                              </Table.Cell>
                              <Table.Cell width={2}>
                                {treatment.tariffInfo}
                              </Table.Cell>
                              <Table.Cell width={2}>
                                {numberFormatter.format(treatment.price)}
                              </Table.Cell>
                              <Table.Cell width={2}>
                                {treatment.patientExternalId}
                              </Table.Cell>
                              <Table.Cell width={2}>
                                {treatment.patientAppId}
                              </Table.Cell>
                              <Table.Cell width={2}>
                                {treatment.patientName}, {treatment.patientFirstName}
                              </Table.Cell>
                              <Table.Cell width={2}>
                                {treatment.patientCity}
                              </Table.Cell>
                              <Table.Cell width={2}>
                                {treatment.patientBirthDate}
                              </Table.Cell>
                            </Table.Row>
                        );
                      })
                  }
                </FieldArray>
              </Table.Body>
            </Table>
          </ScrollableTableWrapper>
        </StyledFlexContainer>
    );
  };

}

export default withMessages(withAuthContext(CollectiveBillTreatmentsTable));
